import { Form } from 'factorial-form'
import { computed, makeObservable } from 'mobx'
import moment from 'moment'

import { stringToDate } from 'modules/core/lib/dates'

import leaves from 'modules/timeoff/store/collections/leaves'
import type Leave from 'modules/timeoff/store/models/Leave'

class LeaveUpdateForm extends Form {
  constructor(values: {}) {
    super(values, {
      leave_id: 'number',
      leave_update_type: 'string',
      document: 'file',
      medical_discharge_reason: 'string',
      colegiate_number: 'string',
      effective_on: 'date',
      hospital_finish_on: 'date',
    })
    makeObservable(this, {
      leave: computed,
    })
  }

  get leave(): Leave {
    const leaveId = +this.get('leave_id').value

    const leave = leaves.find({
      id: leaveId,
    })

    if (!leave) {
      throw Error(`Error finding leaves with id = ${leaveId}`)
    }

    return leave
  }

  hasLeaveStarted() {
    const today = moment()
    const start = stringToDate(this.leave.attributes.start_on, 'backend')

    return today.isSameOrAfter(start)
  }
}

export default LeaveUpdateForm
